import type { FooterSocialMediaLink } from '../../types/footer-social';

/** Curated public social profiles for the global footer (order is display order). */
export const FOOTER_SOCIAL_MEDIA_LINKS: readonly FooterSocialMediaLink[] = [
  { href: 'https://www.instagram.com/jobcrawls/', label: 'Instagram', icon: 'instagram' },
  {
    href: 'https://www.facebook.com/jobcrawls',
    label: 'Facebook',
    icon: 'facebook',
  },
  { href: 'https://fi.pinterest.com/jobcrawls/', label: 'Pinterest', icon: 'pinterest' },
  { href: 'https://x.com/jobcrawls', label: 'X', icon: 'x' },
  { href: 'https://www.linkedin.com/company/jobcrawls-com/', label: 'LinkedIn', icon: 'linkedin' },
  { href: 'https://mastodon.social/@JobCrawls', label: 'Mastodon', icon: 'mastodon' },
  { href: 'https://bsky.app/profile/jobcrawls.bsky.social', label: 'Bluesky', icon: 'bluesky' },
  { href: 'https://www.threads.com/@jobcrawls?hl=en', label: 'Threads', icon: 'threads' },
  { href: 'https://www.tiktok.com/@jobcrawls.com', label: 'TikTok', icon: 'tiktok' },
  { href: 'https://www.reddit.com/r/JobCrawls/', label: 'Reddit', icon: 'reddit' },
  { href: 'https://wellfound.com/company/jobcrawls-com', label: 'Wellfound', icon: 'wellfound' },
  { href: 'https://www.trustpilot.com/review/jobcrawls.com', label: 'Trustpilot', icon: 'trustpilot' },
  {
    href: 'https://play.google.com/store/apps/details?id=com.jobcrawls.mobile',
    label: 'Google Play',
    icon: 'googleplay',
  },
];
